import React from 'react';

import { TLinkCard } from './linkKort.definition';

const LinkKort = (props: TLinkCard) => {
	const { showBorder, showDot, showDotGrey, ikon, url, target, title } = props;

	return (
		<a
			href={ url }
			target={ target }
			className={ [
				'link-kort',
				showBorder ? 'is-highlighted' : ''
			].join(' ') }
		>
			<div className="link-kort__wrapper">
				{ showDot && <div className={ ['link-kort__alert', showDotGrey ? 'grey' : ''].join(' ') } /> }
				{ ikon && <div className={ [ikon, 'link-kort__ikon'].join(' ') } /> }
				<div className="link-kort__title">{ title }</div>
			</div>
		</a>
	);
};

export default LinkKort;
